// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__header--tcg1n {
  padding: 12px 24px 16px 24px;
  position: relative;
}
.src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__header--tcg1n::before {
  position: absolute;
  content: "";
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 4px;
  background-color: #fff5d4;
  border-radius: 4px;
}
.src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__content--gc4kD {
  position: relative;
  z-index: 1000;
}
.src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__text--PFRq9 {
  width: 100%;
}
.src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__cancelButton--FWaBc {
  background: transparent;
  border-color: rgba(0, 0, 0, 0.88);
}
`, "",{"version":3,"sources":["webpack://./src/components/EntityEditor/EntityConfirmHeader/EntityConfirmHeader.module.less"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AAGA;EACE,kBAAA;EACA,aAAA;AADF;AAIA;EACE,WAAA;AAFF;AAKA;EACE,uBAAA;EACA,iCAAA;AAHF","sourcesContent":[".header {\n  padding: 12px 24px 16px 24px;\n  position: relative;\n\n  &::before {\n    position: absolute;\n    content: \"\";\n    z-index: 999;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 4px;\n    background-color: #fff5d4;\n    border-radius: 4px;\n  }\n}\n\n.content {\n  position: relative;\n  z-index: 1000;\n}\n\n.text {\n  width: 100%;\n}\n\n.cancelButton {\n  background: transparent;\n  border-color: rgba(0, 0, 0, 0.88);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__header--tcg1n`,
	"content": `src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__content--gc4kD`,
	"text": `src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__text--PFRq9`,
	"cancelButton": `src-components-EntityEditor-EntityConfirmHeader-EntityConfirmHeader-module__cancelButton--FWaBc`
};
export default ___CSS_LOADER_EXPORT___;
